module.exports = __webpack_public_path__ + "static/icons/icon-unlock--primary-cb371f37b780378337168a4a93875c3c.svg";